<template>
  <BaseBlock title="Dossiers à finaliser">
    <v-container>
      <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Filtres de recherche
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row align="center">
              <v-col cols="2">
                <v-text-field
                  v-model="search.etablissement"
                  label="établissement"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="search.demandeur"
                  label="demandeur"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-checkbox
                  v-model="search.avisBloque"
                  label="avis bloqué"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="2">
                <v-checkbox
                  v-model="search.avisNonBloque"
                  label="avis non bloqués"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
            <SearchDateWidget
              :searchOnDate="search.searchOnDate"
              v-on:update:searchOnDate="search.searchOnDate = $event"
              :dateMin="search.dateMin"
              v-on:update:dateMin="search.dateMin = $event"
              :dateMax="search.dateMax"
              v-on:update:dateMax="search.dateMax = $event"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-data-table
        :headers="headers"
        :items="dossiersAFinaliser"
        v-if="dossiers"
      >
        <!-- template du header "voir" -->
        <template v-slot:[`header.dossier`]="{}">
          <v-icon>mdi-eye</v-icon>
        </template>
        <!-- template des cellules "voir" -->
        <template v-slot:[`item.dossier`]="{ item }">
          <LinkToPDFWidget :dossier="item" />
        </template>
        <!-- template des cellules "établissement" -->
        <template v-slot:[`item.officine.denomination`]="{ item }">
          <div class="text-body-2">{{ item.officine.denomination }}</div>
          <div class="text-caption grey--text font-italic">
            {{ item.officine.codePostal }}
            -
            {{ item.officine.ville }}
          </div>
        </template>
        <!-- template des cellules "demandeur" -->
        <template v-slot:[`item.demandeur`]="{ item }">
          <div class="text-body-2">{{ item.demandeur }}</div>
          <div class="text-caption grey--text font-italic">
            <a
              target="_blank"
              :href="
                `mailto:${item.contactMail}?subject=Pharmagrément - Suivi du dossier de demande d'agrément de: ${item.officine.denomination}`
              "
            >
              {{ item.contactMail }}
            </a>
          </div>
        </template>
        <!-- template des cellules "date" -->
        <template v-slot:[`item.dateDepot`]="{ item }">
          <div class="text-body-2">{{ getDate(item.dateDepot) }}</div>
        </template>
        <!-- template des cellules "date" -->
        <template v-slot:[`item.etat`]="{ item }">
          <div v-if="isAttente(item)" class="text-body-2">
            En attente
          </div>
          <div v-else-if="isExamenCRA(item)" class="text-body-2">
            Examen CRA
          </div>
          <div v-else>Anomalie d'état</div>
        </template>
        <!-- template des cellules "avisCROP" -->
        <template v-slot:[`item.avisCROP`]="{ item }">
          <div class="text-body-2 text-center">
            {{
              item.avisCROP ? getAvisLibelle(item.avisCROP.avis) : "Pas d'avis"
            }}
          </div>
          <div>
            <v-btn
              v-if="item.avisCROP && item.avisCROP.avis !== null"
              @click="openVoirAvisCROPDialog(item)"
              style="float:right"
              x-small
            >
              Voir l'avis...
            </v-btn>
          </div>
        </template>
        <!-- template des cellules "avisRPO" -->
        <template v-slot:[`item.avisRPO`]="{ item }">
          <div class="text-body-2 text-center">
            {{
              item.avisRPO ? getAvisLibelle(item.avisRPO.avis) : "Pas d'avis"
            }}
          </div>
          <div>
            <v-btn
              v-if="item.avisRPO && item.avisRPO.avis !== null"
              @click="openVoirAvisRPODialog(item)"
              style="float:right"
              x-small
            >
              Voir l'avis...
            </v-btn>
          </div>
        </template>
        <!-- template des cellules "actions" -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="text-center">
            <div>
              <v-btn
                v-if="isExamenCRA(item)"
                @click="debloquerAvis(item)"
                x-small
              >
                débloquer les avis
              </v-btn>
            </div>
            <div>
              <v-btn v-if="isAttente(item)" @click="bloquerAvis(item)" x-small>
                bloquer les avis
              </v-btn>
            </div>
            <div>
              <v-btn
                @click="openFinalisationDialog(item)"
                :disabled="!isExamenCRA(item)"
                x-small
              >
                finaliser la demande
              </v-btn>
            </div>
          </div>
        </template>
      </v-data-table>
      <v-btn @click="bloquerModificationAvis()" x-small>
        Bloquer les modifications des avis de l'ensemble des dossiers
      </v-btn>
      <v-btn @click="telechargerTout()" x-small>
        Télécharger l'ensemble des dossiers et avis (.zip)
      </v-btn>
      <v-btn @click="extractionCSV()" x-small>
        Extraction des informations (.csv)
      </v-btn>
    </v-container>
    <!-- popup voir avis du CROP -->
    <ModalVoirAvisCROP
      :avis="currentAvisCROP"
      :display="modalVoirAvisCROPDisplay"
      v-on:update:display="modalVoirAvisCROPDisplay = $event"
      v-if="modalVoirAvisCROPDisplay"
    />
    <!-- popup voir avis du RPO -->
    <ModalVoirAvisRPO
      :avis="currentAvisRPO"
      :display="modalVoirAvisRPODisplay"
      v-on:update:display="modalVoirAvisRPODisplay = $event"
      v-if="modalVoirAvisRPODisplay"
    />
    <ModalFinalisation
      :dossier="currentDossier"
      :display="modalFinalisationDisplay"
      v-on:update:display="modalFinalisationDisplay = $event"
      v-on:ModalFinalisationAction="finaliserDemande($event)"
      v-if="modalFinalisationDisplay"
    />
    <ModalZipProgress
      :progress="progress"
      :display="modalZipProgressDisplay"
      v-if="modalZipProgressDisplay"
    />
  </BaseBlock>
</template>

<script>
import { mapState } from "vuex";
import { saveAs } from "file-saver";
import common from "@/common";
import ApiAvisCROPRepository from "@/repositories/ApiAvisCROPRepository";
import ApiAvisRPORepository from "@/repositories/ApiAvisRPORepository";
import ApiDossierRepository from "@/repositories/ApiDossierRepository";
import BaseBlock from "@/components/base/BaseBlock";
import LinkToPDFWidget from "@/components/LinkToPDFWidget";
import SearchDateWidget from "@/components/SearchDateWidget";
import ModalVoirAvisCROP from "@/components/ModalVoirAvisCROP";
import ModalVoirAvisRPO from "@/components/ModalVoirAvisRPO";
import ModalFinalisation from "@/components/ModalFinalisation";
import ModalZipProgress from "@/components/ModalZipProgress";

export default {
  name: "RecevabiliteDesDemandes",
  components: {
    BaseBlock,
    LinkToPDFWidget,
    ModalVoirAvisCROP,
    ModalVoirAvisRPO,
    ModalFinalisation,
    ModalZipProgress,
    SearchDateWidget
  },
  data() {
    return {
      refresh_dossier_timer: null,
      modalVoirAvisCROPDisplay: false,
      modalVoirAvisRPODisplay: false,
      modalFinalisationDisplay: false,
      modalZipProgressDisplay: false,
      currentAvisCROP: null,
      currentAvisRPO: null,
      currentDossier: null,
      search: {
        etablissement: "",
        demandeur: "",
        avisBloque: true,
        avisNonBloque: true,
        searchOnDate: false,
        dateMin: null,
        dateMax: null
      },
      headers: [
        {
          align: "center",
          sortable: false,
          value: "dossier"
        },
        {
          text: "Etablissement",
          align: "start",
          sortable: true,
          value: "officine.denomination"
        },
        {
          text: "Demandeur",
          align: "start",
          sortable: true,
          value: "demandeur"
        },
        {
          text: "Date de dépot de la demande",
          align: "start",
          sortable: true,
          value: "dateDepot"
        },
        {
          text: "Etat",
          align: "start",
          sortable: true,
          value: "etat"
        },
        {
          text: "Avis du CROP",
          align: "start",
          sortable: false,
          value: "avisCROP"
        },
        {
          text: "Avis du responsable de parcours",
          align: "start",
          sortable: false,
          value: "avisRPO"
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
          value: "actions"
        }
      ],
      progress: { avancement: null, fichier: null }
    };
  },
  computed: {
    ...mapState(["dossiers", "user"]),
    dossiersAFinaliser() {
      return this.dossiers
        .filter(d => {
          if (!d.avisCROP || !d.avisRPO) return false;
          if ("" !== this.search.etablissement) {
            if (
              !d.officine ||
              !d.officine.denomination
                .toLowerCase()
                .includes(this.search.etablissement)
            )
              return false;
          }
          if ("" !== this.search.demandeur) {
            if (!d.contactPrenom || !d.contactNom) return false;
            if (
              !(d.contactPrenom + " " + d.contactNom)
                .toLowerCase()
                .includes(this.search.demandeur)
            )
              return false;
          }
          // On ne veut pas voir les dossiers avec avis bloqués (examen CRA)
          if (false === this.search.avisBloque && common.isExamenCRA(d)) {
            return false;
          }
          // On ne veut pas voir les dossiers avec avis nonbloqués (en attente)
          if (false === this.search.avisNonBloque && common.isAttente(d)) {
            return false;
          }
          if (
            this.search.searchOnDate &&
            !common.matchDate(d, this.search.dateMin, this.search.dateMax)
          )
            return false;
          return common.isAttente(d) || common.isExamenCRA(d);
        })
        .map(d => {
          d.demandeur = d.contactPrenom + " " + d.contactNom;
          return d;
        }); ///3
    }
  },
  async created() {
    if (null === this.dossiers) await this.loadDossiers();
    else this.loadDossiers();
    this.refresh_dossier_timer = setInterval(
      this.loadDossiers,
      common.REFRESH_TIMER
    );
  },
  beforeDestroy() {
    clearInterval(this.refresh_dossier_timer);
  },
  methods: {
    async loadDossiers() {
      this.$store.dispatch("loadDossiers");
    },
    getDate(timestamp) {
      return common.formatDate(timestamp);
    },
    isAttente(dossier) {
      return common.isAttente(dossier);
    },
    isExamenCRA(dossier) {
      return common.isExamenCRA(dossier);
    },
    getAvisLibelle(avis) {
      return common.getAvisLibelle(avis);
    },
    async debloquerAvis(dossier) {
      dossier = await common.setEtatAttente(dossier);
      this.$store.dispatch("updateDossier", dossier);
      this.$toast.success("Le dossier est à nouveau en attente d'avis.");
      return dossier;
    },
    async bloquerAvis(dossier) {
      dossier = await common.setEtatExamenCRA(dossier);
      this.$store.dispatch("updateDossier", dossier);
      this.$toast.success("Le dossier est en attente d'examen par le CRA.");
      return dossier;
    },
    async bloquerModificationAvis() {
      const affected = await ApiDossierRepository.setAllEtatExamenCRA();
      this.$toast.success(
        "Nombre de nouveaux dossiers bloqués pour l'examen du CRA: " + affected
      );
      this.$store.dispatch("loadDossiers");
    },
    async telechargerTout() {
      await this.$store.dispatch("loadDossiers");
      this.modalZipProgressDisplay = true;
      const zip = await common.dossiersToZip(this.dossiers, this.progress);
      saveAs(zip, "dossiers-CRA.zip");
      this.modalZipProgressDisplay = false;
    },
    async extractionCSV() {
      await this.$store.dispatch("loadDossiers");
      const csv = common.toCSVSummary(this.dossiers);
      const data = encodeURI(csv);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "tableauCRA.csv");
      link.click();
    },
    envoyerMailInscription(dossier) {
      common.sendMailInscription(dossier);
      this.$toast.success("Le code a été renvoyé.");
    },
    async openVoirAvisCROPDialog(dossier) {
      if (
        !(
          this.currentAvisCROP &&
          dossier.avisCROP &&
          this.currentAvisCROP.id === dossier.avisCROP.id
        )
      )
        this.currentAvisCROP = await ApiAvisCROPRepository.get(
          dossier.avisCROP.id
        );
      this.modalVoirAvisCROPDisplay = true;
    },
    async openVoirAvisRPODialog(dossier) {
      if (
        !(
          this.currentAvisRPO &&
          dossier.avisRPO &&
          this.currentAvisRPO.id === dossier.avisRPO.id
        )
      )
        this.currentAvisRPO = await ApiAvisRPORepository.get(
          dossier.avisRPO.id
        );
      this.modalVoirAvisRPODisplay = true;
    },
    openFinalisationDialog(dossier) {
      if (null === this.currentDossier || this.currentDossier.id !== dossier.id)
        this.currentDossier = dossier;
      this.modalFinalisationDisplay = true;
    },
    async finaliserDemande(dossier) {
      if (dossier.decisionCRA) dossier = await common.setEtatValide(dossier);
      else dossier = await common.setEtatRefuse(dossier);
      this.$store.dispatch("updateDossier", dossier);
      this.$toast.success("La demande d'agrément a bien été finalisée.");
    }
  }
};
</script>
